import { createTheme as a } from "../../_mixins/use-theme.js";
import l from "../../_styles/common/light.js";
import i from "../../_internal/scrollbar/styles/light.js";
import e from "../../dialog/styles/light.js";
import c from "../../card/styles/light.js";
function d(o) {
  const {
    modalColor: r,
    textColor2: t,
    boxShadow3: m
  } = o;
  return {
    color: r,
    textColor: t,
    boxShadow: m
  };
}
const h = a({
  name: "Modal",
  common: l,
  peers: {
    Scrollbar: i,
    Dialog: e,
    Card: c
  },
  self: d
}), L = h;
export {
  L as default,
  d as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/modal/styles/light.js
// module id = 1721
// module chunks = 67